import { getContextPath } from "../shared/application.js";

document
  .getElementById("btnBack")
  ?.addEventListener("click", () =>
    window.location.assign(`${getContextPath()}/`)
  );
